import CardTitle from '@auteco/components/sharedComponents/CardTitle';
import { Box, TextField, Button } from '@material-ui/core'
import React, { useState } from 'react'
import { Autocomplete } from '@material-ui/lab';
import ActionsTable from './ActionsTable';
import BossesTable from './BossesTable';
import CountryCards from './CountryCards'
import ManagersTable from './ManagersTable';
import PartnersTable from './PartnersTable';
import QuizzesTable from './QuizzesTable';
import { useStyles } from './styles';
import ModulesCards from './ModulesCards';
import TableModules from './TableModules';
import TableQuizzesScore from './TableQuizzesScore';
import TableActionsAreas from './TableActionsAreas';


const IndicatorsPage = ({
  submitInfo,
  countryInfo,
  infoManagers,
  bossesInfo,
  infoQuizzes,
  infoPartners,
  infoActions,
  filterPartners,
  filterBosses,
  groupList,
  modulesCountry,
  partnerModule,
  partnersQuizzesScore,
  actionsAreas
  }) => {
  const [initialDay, setInitialDay] = useState()
  const [finalDay, setFinalDay] = useState('')
  const [submited, setSubmited] = useState()
  const [selectedGroup, setSelectedGroup] = useState('')
  const [selectedPage, setSelectedPage] = useState('1')
  const classes = useStyles()

  const modules = [
    'Portafolio',
    'Logística y procesos',
    'Planeación Comercial y Mercadeo',
    'Inteligencia de Mercados (Análisis de Competencia)',
    'Servicio al cliente',
    'Compensación y retención del talento',
    'Capacidades desarrolladas',
    'Sostenibilidad y alineación con la estrategia corporativa'
  ]

  const groupData = (array, feature) => {
    const groupedData = array.reduce((acc, item) => {
      if (!acc[item[feature]]) {
        acc[item[feature]] = [item];
      } else {
        acc[item[feature]].push(item);
      }
      return acc;
    }, {});

    const result = Object.values(groupedData);
    return result
  }
  const groups = [{id:'Todos'},...groupList]

  const onSubmit = () => {
    const body = {
      since: initialDay,
      until: finalDay,
      idGrupo: selectedGroup.id === 'Todos' ? 0 : selectedGroup.id
    }
    submitInfo(body)
    setTimeout(() => setSubmited(true), 2000)
  }

  const arrays = [Object.values(countryInfo), infoManagers, bossesInfo, infoPartners, infoQuizzes, infoActions]
  return (
    <div>
      <CardTitle title='Indicadores' />
      <Box style={{background: 'white', padding: '40px'}}>
        <h3 className={classes.subTitle} >Seleccione el periodo y grupo a consultar</h3>
        <Box className={classes.inputsContainer}>
          <Box className={classes.inputContainer}>
            <p>Desde</p>
            <TextField type='date' variant='outlined' onChange={(e) => setInitialDay(e.target.value)}/>
          </Box>
          <Box className={classes.inputContainer}>
            <p>Hasta</p>
            <TextField type='date' variant='outlined' onChange={(e) => setFinalDay(e.target.value)}/>
          </Box>
          <Box className={classes.inputContainer}>
            <Autocomplete
              autoComplete
              options={groups}
              onChange={(_, value) => {
                setSelectedGroup(value)
              }}
              getOptionLabel={(option) => option.id || ''}
              style={{
              width: '200px',
              margin: '0 auto',
              }}
              renderInput={(params) => (
              <TextField
              {...params}
              label="Grupos"
            />
          )}
            />
          </Box>
          <Button
            className={!(initialDay && finalDay && selectedGroup ) ? classes.buttonSubmitDisabled : classes.buttonSubmit}
            disabled={!(initialDay && finalDay && selectedGroup )}
            onClick={() => onSubmit()}
          >
            Buscar
          </Button>
        </Box>
        {(!(arrays.some(array => array.length > 0)) && submited) && <p className={classes.warningText}>No hay información disponible para mostrar en este periodo</p>}
        {Object.values(countryInfo).length > 0 ?
          <CountryCards countryInfo={countryInfo} />
          : null
        }
        {submited &&
          <Box className={classes.inputsContainer} style={{ paddingLeft: '40px' }}>
            <Button className={classes.buttonPage} onClick={() => setSelectedPage('1')}>Página 1</Button>
            <Button className={classes.buttonPage} onClick={() => setSelectedPage('2')}>Página 2</Button>
          </Box>
        }
        {selectedPage === '1' &&
          <Box>
            {infoManagers.length > 0 ?
          <ManagersTable info={infoManagers} filterBosses={filterBosses}/>
          : null}
          {bossesInfo.length > 0 ?
          <BossesTable info={bossesInfo} filterPartners={filterPartners}/>
            : null}
          {infoPartners.length > 0  ?
          <PartnersTable info={infoPartners} />
            : null}
          {infoQuizzes.length > 0 ?
          <QuizzesTable info={infoQuizzes} />
            : null}
          {infoActions.length > 0 ?
          <ActionsTable info={infoActions} />
          : null}
          </Box>
        }
        {selectedPage === '2' &&
          <Box>
            {modulesCountry.length > 0 ?
              <ModulesCards info={modulesCountry} modules={modules} />
              : null}
            {partnerModule.length > 0 ?
              <TableModules info={partnerModule} modules={modules} groupData={groupData} />
              : null}
            {partnersQuizzesScore.length > 0 ?
              <TableQuizzesScore info={partnersQuizzesScore} groupData={groupData} modules={modules} />
              : null}
            {actionsAreas.length > 0 ?
              <TableActionsAreas info={actionsAreas} groupData={groupData} />
              : null}
          </Box>
        }
      </Box>
    </div>
  )
}

export default IndicatorsPage